import React from "react";

function EditAction() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#eaac9d"
        d="M144.708 399.964c-16.895 0-30.591-13.696-30.591-30.591V240.979c0-16.895 13.696-30.591 30.591-30.591s30.591 13.696 30.591 30.591v128.393c.001 16.895-13.696 30.592-30.591 30.592zm61.183 0c-16.895 0-30.591-13.696-30.591-30.591V231.597c0-16.895 13.696-30.591 30.591-30.591s30.591 13.696 30.591 30.591v137.775c.001 16.895-13.696 30.592-30.591 30.592z"
        data-original="#eaac9d"
      ></path>
      <path
        fill="#df9380"
        d="M144.708 210.388a30.467 30.467 0 00-12.906 2.855c10.444 4.868 17.686 15.454 17.686 27.736v128.393c0 12.282-7.242 22.868-17.686 27.736a30.467 30.467 0 0012.906 2.855c16.895 0 30.591-13.696 30.591-30.591V240.979c.001-16.895-13.696-30.591-30.591-30.591zm61.183-9.382a30.467 30.467 0 00-12.906 2.855c10.444 4.868 17.686 15.454 17.686 27.736v137.775c0 12.282-7.242 22.868-17.686 27.736a30.467 30.467 0 0012.906 2.855c16.895 0 30.591-13.696 30.591-30.591V231.597c.001-16.895-13.696-30.591-30.591-30.591z"
        data-original="#df9380"
      ></path>
      <path
        fill="#ffddce"
        d="M361.003 219.409a30.593 30.593 0 01-16.616-4.906l-74.792-48.383c-9.587-6.223-20.864-9.345-32.282-9.102l-.001.001c-3.013-.02-6.08.408-9.114 1.331l-120.8 36.757a55.306 55.306 0 00-29.524 21.721L20.342 301.36c-9.43 13.855-6.493 32.986 7.165 42.698a30.463 30.463 0 0017.714 5.673c9.783 0 19.398-4.684 25.317-13.382l52.669-77.386a20.394 20.394 0 0110.923-8.036l39.708-12.082a26.329 26.329 0 0132.818 32.962c-2.575 12.92-12.975 23.483-26.619 23.295h-63.526c-16.669 0-30.759 13.069-31.216 29.731-.474 17.288 13.399 31.452 30.58 31.452h72.028a60.947 60.947 0 0126.829 6.222l26.8 13.136a60.95 60.95 0 0026.829 6.222h51.727c9.979 0 19.848-2.661 28.218-8.093a52.37 52.37 0 0128.507-8.439h52.246V219.409z"
        data-original="#ffddce"
      ></path>
      <path
        fill="#21386b"
        d="M7.648 425.437a7.649 7.649 0 01-5.408-13.056l21.09-21.091a7.649 7.649 0 0110.816 10.815l-21.09 21.091a7.624 7.624 0 01-5.408 2.241z"
        data-original="#21386b"
      ></path>
      <path
        fill="#335995"
        d="M330.581 134.895l-21.973 21.973-21.546 10.763-9.81 20.592L78.666 386.81a37.207 37.207 0 01-10.703 7.467L40.909 406.78c-14.157 6.543-28.795-8.096-22.253-22.253l12.503-27.054a37.207 37.207 0 017.467-10.703l198.587-198.587 24.671-10.606 6.684-20.749 21.973-21.973c11.057-11.057 28.983-11.057 40.039 0 11.057 11.057 11.057 28.983.001 40.04z"
        data-original="#335995"
      ></path>
      <path
        fill="#26457d"
        d="M40.909 406.779l27.054-12.503a37.207 37.207 0 0010.703-7.467l198.587-198.587 9.81-20.592 21.546-10.763 21.973-21.973c11.057-11.057 11.057-28.983 0-40.039a28.226 28.226 0 00-9.215-6.154c4.229 10.256 2.18 22.491-6.154 30.824L27.6 407.138c3.981 1.645 8.669 1.786 13.309-.359z"
        data-original="#26457d"
      ></path>
      <path
        fill="#f6e266"
        d="M237.173 148.197l31.35-31.35 40.034 40.033-31.35 31.35z"
        data-original="#f6e266"
      ></path>
      <path
        fill="#f1d333"
        d="M261.84 172.866l31.35-31.35 15.367 15.366-31.35 31.35z"
        data-original="#f1d333"
      ></path>
      <path
        fill="#ffddce"
        d="M361.003 219.409a30.593 30.593 0 01-16.616-4.906l-56.722-36.693-80.485 80.485a26.251 26.251 0 01-.524 13.51c-2.575 12.92-12.975 23.483-26.619 23.295h-63.526c-16.669 0-30.759 13.069-31.216 29.731-.474 17.288 13.399 31.452 30.58 31.452h72.028a60.947 60.947 0 0126.829 6.222l26.8 13.136a60.95 60.95 0 0026.829 6.222h51.727c9.979 0 19.848-2.661 28.219-8.093a52.37 52.37 0 0128.507-8.439h52.246V219.409z"
        data-original="#ffddce"
      ></path>
      <path
        fill="#ffcbbe"
        d="M348.306 339.617c-8.371 5.432-18.24 8.093-28.218 8.093h-51.727a60.947 60.947 0 01-26.829-6.222l-26.8-13.136a60.961 60.961 0 00-26.829-6.222h-72.028c-10.529 0-19.809-5.325-25.312-13.422-3.172 4.62-5.103 10.138-5.267 16.125-.474 17.288 13.399 31.452 30.58 31.452h72.028a60.947 60.947 0 0126.829 6.222l26.8 13.136a60.95 60.95 0 0026.829 6.222h51.727c9.979 0 19.848-2.661 28.218-8.093a52.37 52.37 0 0128.507-8.439h52.246v-34.154h-52.246a52.364 52.364 0 00-28.508 8.438z"
        data-original="#ffcbbe"
      ></path>
      <path
        fill="#e7ecf6"
        d="M507 382.433h-84.763a5 5 0 01-5-5V211.782a5 5 0 015-5H507a5 5 0 015 5v165.651a5 5 0 01-5 5z"
        data-original="#e7ecf6"
      ></path>
      <path
        fill="#d5dff4"
        d="M507 206.782h-18.294v147.357a5 5 0 01-5 5h-66.47v18.294a5 5 0 005 5H507a5 5 0 005-5V211.782a5 5 0 00-5-5z"
        data-original="#d5dff4"
      ></path>
      <circle
        cx="452.161"
        cy="342.19"
        r="10.693"
        fill="#335995"
        data-original="#335995"
      ></circle>
    </svg>
  );
}

export default EditAction;
